import { apiRequest, getResource } from "../api/http";

// Logs tab: failed payments, CinetPay, server log (/api/admin/monitoring, admin token).

const BASE = "/api/admin/monitoring";

const query = (params) => {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") search.set(key, String(value));
  });
  const text = search.toString();
  return text ? `?${text}` : "";
};

const EMPTY_PAGE = { items: [], total: 0, page: 1, pageSize: 25 };

export const getPaymentStats = (days = 30) => getResource(`${BASE}/payments/stats${query({ days })}`, { fallback: null });
export const getFailedPayments = (params) => getResource(`${BASE}/payments/failed${query(params)}`, { fallback: EMPTY_PAGE });
export const getPastDue = () => getResource(`${BASE}/payments/past-due`, { select: (d) => d.items || [], fallback: [] });
export const getCardDeclines = (params) => getResource(`${BASE}/payments/card-declines${query(params)}`, { fallback: EMPTY_PAGE });
export const getPaymentTimeline = (id) => getResource(`${BASE}/payments/${id}/timeline`, { fallback: null });

export const reviewPayment = (id, status, note) =>
  apiRequest("post", `${BASE}/payments/${id}/review`, { data: { status, note }, rethrow: true });
export const recheckPayment = (id) => apiRequest("post", `${BASE}/payments/${id}/recheck`, { rethrow: true });
export const remindPayment = (id) => apiRequest("post", `${BASE}/payments/${id}/remind`, { rethrow: true });
export const syncSubscription = (id) =>
  apiRequest("post", `${BASE}/subscriptions/${id}/sync`, { select: (d) => d.result, rethrow: true });
export const retrySubscription = (id) =>
  apiRequest("post", `${BASE}/subscriptions/${id}/retry`, { select: (d) => d.result, rethrow: true });

export const getMobileStatus = () => getResource(`${BASE}/mobile/status`, { fallback: null });
/** { suspended: { paystack: true } } ou { priority: ["paystack", "cinetpay"] } */
export const updateMobileSettings = (changes) =>
  apiRequest("put", `${BASE}/mobile/settings`, { data: changes, rethrow: true });
export const getMobileTransactions = (params) =>
  getResource(`${BASE}/mobile/transactions${query(params)}`, { fallback: EMPTY_PAGE });
export const lookupMobile = (transactionId) =>
  apiRequest("get", `${BASE}/mobile/transactions/${encodeURIComponent(transactionId)}`, { rethrow: true });
export const pingMobile = (provider, currency) =>
  apiRequest("post", `${BASE}/mobile/ping`, { data: { provider, currency }, rethrow: true });

export const getLogs = (params) => getResource(`${BASE}/logs${query(params)}`, { fallback: { ...EMPTY_PAGE, pageSize: 50 } });
export const getLogStats = () => getResource(`${BASE}/logs/stats`, { fallback: null });

// Activity of the admins (system admins and admins who manage administrators)
export const getAdminActivity = (params) =>
  getResource(`${BASE}/admin-activity${query(params)}`, { fallback: { ...EMPTY_PAGE, pageSize: 50 } });
export const getAdminActivityAdmins = () =>
  getResource(`${BASE}/admin-activity/admins`, { select: (data) => data.admins, fallback: [] });
export const getLogFile = (name, lines) =>
  getResource(`${BASE}/logs/files/${name}${query({ lines })}`, { fallback: { lines: [] } });

export const apiMessage = (error, fallback) => error?.response?.data?.message || fallback;
